import { getQueryStringFromOptions, getResponse } from '@satellite/services/serviceUtilities';
import { cachedInflightRequest } from '@nova/core';

export default {
  async getOneById(observationId, params, options = {}) {
    const queryString = getQueryStringFromOptions(options);

    // Generate a unique cache key
    const cacheKey = `observations/getOneById:${observationId}:${JSON.stringify(
      params
    )}:${queryString}`;

    return cachedInflightRequest(cacheKey, async () => {
      const response = await axios.get(`observations/${observationId}?${queryString}`, {
        params
      });
      return getResponse(response, options);
    });
  },
  async getManyByWarehouseId(warehouseId, params = {}, options = {}) {
    const queryString = getQueryStringFromOptions(options);

    // Generate a unique cache key
    const cacheKey = `observations/getMany:${JSON.stringify(params)}:${queryString}`;

    return cachedInflightRequest(cacheKey, async () => {
      const response = await axios.get(`observations?${queryString}`, {
        params: { ...params, warehouseId }
      });

      return getResponse(response, options);
    });
  },
  async search(warehouseId, params = {}, options = {}) {
    // Generate a unique cache key
    const cacheKey = `observations-search/search:${JSON.stringify(params)}`;

    return cachedInflightRequest(cacheKey, async () => {
      const response = await axios.post(`observations-search/search`, { ...params, warehouseId });

      return getResponse(response, options);
    });
  },
  async getGatesByWarehouseId(warehouseId) {
    const queryString = getQueryStringFromOptions();

    // Generate a unique cache key
    const cacheKey = `gates/getByWarehouseId:${warehouseId}:${queryString}`;

    return cachedInflightRequest(cacheKey, async () => {
      const response = await axios.get(`gates/${warehouseId}`);
      return getResponse(response);
    });
  }
};
